import React, { useMemo, useContext } from 'react';
import { GlobalHotKeys } from 'react-hotkeys';

// Hooks
import { useToggle } from 'Shared/utils/hooks';

// Context
import ExpandNavbarContext from 'Shared/contexts/ExpandNavbarContext';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';
import WpTextField from 'Wpds/components/text-field/WpTextField';
import SearchModal from 'Shared/components/SearchModal';
import { WpTooltip, WpTooltipContent, WpTooltipTrigger } from 'Wpds/components/tooltip';

// Styles
import './SearchButton.scss';

const keyMap = Object.freeze({
  OPEN_SEARCH_MODAL: ['command+k', 'ctrl+k'],
});

const SearchButton = () => {
  const isExpanded = useContext(ExpandNavbarContext);

  const [isOpen, toggleIsOpen] = useToggle(false);

  const handlers = useMemo(
    () => ({
      OPEN_SEARCH_MODAL: event => {
        event.preventDefault();
        toggleIsOpen();
      },
    }),
    []
  );

  const handleKeyPress = e => {
    if (e.keyCode == 13) {
      toggleIsOpen();
    }
  };

  const baseClassName = 'SearchButton';

  return (
    <>
      <GlobalHotKeys keyMap={keyMap} handlers={handlers}>
        {isExpanded ? (
          <div className={baseClassName}>
            <WpTextField
              id="global-search-placeholder"
              label="Search"
              labelHidden
              disabled
              placeholder="Search"
              prefixIcon="search"
              value="Search"
            />
            <div
              className={`${baseClassName}__overlay`}
              onClick={toggleIsOpen}
              role="button"
              tabIndex={0}
              onKeyDown={handleKeyPress}
            />
          </div>
        ) : (
          <WpTooltip placement="right">
            <WpTooltipTrigger>
              <li className="nav-item" onClick={toggleIsOpen}>
                <div className="nav-link d-flex align-items-center cursor-pointer">
                  <div className="side-navigation-icon position-relative mx-auto">
                    <WpIcon name="search" />
                  </div>
                </div>
              </li>
            </WpTooltipTrigger>
            <WpTooltipContent>Search</WpTooltipContent>
          </WpTooltip>
        )}
        {isOpen && <SearchModal isOpen onOpenToggle={toggleIsOpen} />}
      </GlobalHotKeys>
    </>
  );
};

export default SearchButton;
